// Application constants

// Default values
export const DEFAULT_ESTIMATED_USAGE = 1000 // kWh/month

// Storage keys
export const STORAGE_KEYS = {
  USER_ID: 'cp_user_id',
  ADDRESS_DATA: 'addressData',
  PROPERTY_DATA: 'propertyData',
  PERSONAL_INFO: 'personalInfo',
  SELECTED_PLANS: 'selectedPlans',
  WATER_AVAILABLE: 'waterAvailable',
  SERVICE_DATA: 'serviceData',
  SKIP_PROPERTY_SCREEN: 'skipPropertyScreen',
  INTERNET_PLANS: 'internetPlans',
  ELECTRICITY_PLANS: 'electricityPlans',
  WATER_PLAN_DATA: 'waterPlanData',
} as const

// View/Step mappings
export const VIEW_INDICES = {
  ADDRESS_ENTRY: 0,
  SERVICE_AVAILABLE: 1,
  PROPERTY_CONFIRMATION: 2,
  PERSONAL_INFO: 3,
  UTILITIES_SELECTION: 4,
  PLAN_OPTIONS: 5,
  SERVICE_SETUP: 6,
  DOCUMENT_UPLOAD: 7,
  ORDER_CONFIRMATION: 8,
  ORDER_STATUS: 9,
} as const

// Step labels for progress indicators
export const STEP_LABELS = {
  1: 'Property',
  2: 'Personal Info',
  3: 'Utilities',
  4: 'Setup',
  5: 'Confirmation',
} as const

// Usage calculation constants
export const USAGE_CALCULATION = {
  BASE_KWH_PER_SQFT: 0.5, // Texas baseline
  EFFICIENCY_MULTIPLIERS: {
    BEFORE_1980: 1.25,
    YEAR_1980_1999: 1.1,
    YEAR_2000_2009: 1.0,
    YEAR_2010_2019: 0.9,
    AFTER_2019: 0.85,
  },
} as const

// File upload limits.
// Keep meaningful headroom below the platform ceiling for multipart boundaries,
// checkout JSON payload, and Netlify/Lambda base64 expansion.
export const FILE_UPLOAD_LIMITS = {
  MAX_SINGLE_FILE_MB: 4,
  MAX_COMBINED_FILES_MB: 4,
} as const

// API endpoints
export const API_ENDPOINTS = {
  FCC_BROADBAND: '/api/fcc-broadband/serviceability',
  TURNITON_PLANS: '/api/2turniton/services',
  COMPAREPOWER_PLANS: '/api/comparepower/plans',
  ERCOT_USAGE: '/api/ercot/usage-profile',
} as const
